import GlobalConnectionItem from './GlobalConnectionItem';

const GlobalConnectionList = ({
  connections,
  onInitiateOauth,
  onSaveCustom,
}) => {
  // Don't render the section if there are no global connections to show
  if (!connections || connections.length === 0) {
    return null;
  }

  return (
    <div className="space-y-8">
      <div>
        <div className="flex flex-wrap gap-x-4 gap-y-4 pb-4 max-sm:flex-col max-sm:items-center">
          {connections.map((conn) => (
            <GlobalConnectionItem
              key={conn.id}
              globalConn={conn}
              onInitiateOauth={onInitiateOauth}
              onSaveCustom={onSaveCustom}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GlobalConnectionList;
